var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_order_card"},[_c('div',{staticClass:"title",class:{
                'border-bottom':_vm.border
            }},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }